export default __webpack_public_path__ + "static/media/section2b-grid6img.0a1b01b6.svg";